// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3R1xi","PrimaryButton":"Button_PrimaryButton__2bmJu","SecondaryButton":"Button_SecondaryButton__1B_zI"};